import { render, staticRenderFns } from "./three.vue?vue&type=template&id=296d39aa"
import script from "./three.vue?vue&type=script&lang=js"
export * from "./three.vue?vue&type=script&lang=js"
import style0 from "./three.vue?vue&type=style&index=0&id=296d39aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports